export default "__VITE_ASSET__m4vevNJK__"